export default "__VITE_ASSET__BpO72M9q__"